import CheckCircle from '@mui/icons-material/CheckCircle';
import AddCircle from '@mui/icons-material/AddCircle';
import React from 'react';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import AssessmentIcon from '@mui/icons-material/Assessment';

interface IToggleChipProps {
    value: string;
    label?: string;
    selected: boolean;
    flag?: boolean;
    onSelect: (value: string) => void;
    disabled?: boolean;
    tooltip?: string;
    showsOnReport?: boolean;
}

// Note: This component is a little bit grog. If you want to prevent this chip from being shown as an option
// on the power BI report, you need to set showsOnReport to false or null 
// and disable the chip to prevent it from being selected from the report view

export class ToggleChip extends React.Component<IToggleChipProps> {
    HandleClick = () => {
        if (!this.props.disabled) {
            const newValue = this.props.flag !== false
                ? `flag${this.props.value.replace(/ /g, '')}`
                : this.props.value;
            this.props.onSelect(newValue);
        }
    };

    render() {
        const { label, value, selected, disabled, tooltip, showsOnReport } = this.props;
        const chip = (
            <Chip
                icon={showsOnReport ? <AssessmentIcon /> : undefined}
                color={selected ? 'secondary' : 'default'}
                label={label || value}
                clickable={!disabled}
                onClick={this.HandleClick}
                onDelete={this.HandleClick}
                deleteIcon={selected ? <CheckCircle /> : <AddCircle />}
                disabled={disabled}
            />
        );

        return (
            <Grid>
                {tooltip ? (
                    <Tooltip placement="top-start" title={tooltip}>
                        {chip}
                    </Tooltip>
                ) : (
                    chip
                )}
            </Grid>
        );
    }
}
